import router from "./../../router";
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

//const state = {
//};
 
//const mutations = {
//};

const actions = {

    async get_review ({ commit }, payload) {
        return new axios.get('/api/review?type='+payload.type+'&sort='+payload.sort)
        .catch(error => {
            reject(error);
        })
    },

    async check_review ({ commit }, payload) {
        return new axios.get('/api/review/check/'+String(payload.type)+'/'+String(payload.orders_id)+'/'+String(payload.products_id))
        .catch(error => {
            reject(error);
        })
    },
    
    async post_review ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/review', {
                "review": payload.sendForm,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async post_review_comment ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/review_comment', {
                "review_comment": payload.reviewCommentForm,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    

};

export default {
    namespaced: true,
//    state,
//    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/review.js